import React from 'react';

import img_me from '../../images/Polymedia-Peter_van_der_Meer.jpg';


export default class extends React.Component {

  render() {
    return (
      <div>
        <i id="over" />
        {/*Mijn doel is om voor jou meer omzet te genereren.*/}
        <div className="full big black">
          <div className="wrap content-block">
            <div style={{textAlign:"center"}}>
              <h2 style={{margin:"1rem 0 2rem", textAlign:"center"}}>Geen koffie en vlotte babbels.</h2>
              <p style={{fontSize:"1.25em", textAlign:"center", marginTop:"0", marginBottom:"5em"}}>
              Mijn naam is Peter van der Meer, en ik woon in Leerdam (Utrecht). Na jarenlange ervaring met allerlei ondernemingen heb ik genoeg ervaring opgebouwd met marketing dat ik op het idee kwam om als LinkedIn Ghostwriter te beginnen. Mijn doel is om jouw LinkedIn te verbeteren en actiever te maken, zodat jij makkelijker toptalent kunt aantrekken.
              <br/><br/>
              Dit bedrijf werkt volledig remote, ik heb dus ook geen kantoor. Contact gaat in eerste instantie via LinkedIn, 06, e-mail, en videobellen, en ook tijdens onze samenwerking heeft dit mijn voorkeur. Tijdens onze samenwerking kunnen we ook andere manieren van contact afspreken.
              <br/><br/>
              Benieuwd of ik jou kan helpen? Neem geheel vrijblijvend contact met mij op door een bericht te sturen via LinkedIn.
              </p>
              <div style={{marginBottom:"5em"}}><a href="https://www.linkedin.com/in/peterdotplus/" target="blank" className="btn btn-fat btn-if btn-if-fill-gold">Neem contact op via LinkedIn van Peter</a><a href="https://www.linkedin.com/in/peterdotplus/" target="blank"><img src={img_me} alt="Ghostin.nl LinkedIn Ghostwriter | Peter van der Meer" style={{marginTop:"-36px", marginLeft:"14px", borderRadius:"50%", border:"3px solid #E5C88D", width:"90px"}} /></a></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/components/ContactIntro.js